import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-text',
  templateUrl: './mobile-text.component.html',
  styleUrls: ['./mobile-text.component.scss']
})
export class MobileTextComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
